import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getPerfilLaboral, cadastrarPerfilLaboral, alterarPerfilLaboral, excluirPerfilLaboral } from './perfis_laboraris.service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var PerfisLaboraisAlterar = function () {
    var services = {
        getItem: getPerfilLaboral,
        cadastrarItem: cadastrarPerfilLaboral,
        alterarItem: alterarPerfilLaboral,
        excluirItem: excluirPerfilLaboral,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.PERFIS_LABORAIS, paginaPermissao: FUNCIONALIDADES.PERFIS_LABORAIS, rota: ROUTES.PERFIS_LABORAIS, services: services });
};
export default PerfisLaboraisAlterar;
